<script setup lang="ts" name="AdminAcceptUserReviewStep">
import type { RouteLocationRaw } from 'vue-router';

import AdminAcceptUserStepperFooter from '~/components/AdminAcceptUserStepperFooter.vue';
import BaseButton from '~/components/BaseButton.vue';
import CustomCard from '~/components/CustomCard.vue';
import Icon from '~/components/Icon.vue';
import PendingUserInfo from '~/components/PendingUserInfo.vue';
import ServiceCard from '~/components/ServiceCard.vue';

import type { IAdminRequestedUser, IStepperConfig } from '~/types';

const { userListPath, stepperConfig, user, serviceState } = defineProps<{
  userListPath: RouteLocationRaw;
  stepperConfig?: IStepperConfig;
  user?: IAdminRequestedUser;
  serviceState: unknown;
}>();
</script>

<template>
  <ServiceCard v-bind="serviceState">
    <CustomCard title="Review User Information">
      <PendingUserInfo class="px-6 pb-6" :user="user!" />
    </CustomCard>

    <AdminAcceptUserStepperFooter>
      <BaseButton variant="btn-tertiary" :to="userListPath">
        Cancel
      </BaseButton>

      <BaseButton @click="stepperConfig?.onNextStep">
        Next

        <template #rightIcon>
          <Icon icon="mdi:chevron-right" />
        </template>
      </BaseButton>
    </AdminAcceptUserStepperFooter>
  </ServiceCard>
</template>
